import { Box, Stack, Typography } from "@mui/material";
import { IsMdScreen, IsXsScreen } from "helpers/hooks";
import { ResourceTypography } from "Modules/Marketing/Resources/Resources.styled";
import { Link as RouterLink } from "react-router-dom";
import { ShButton } from "shared/SharedStyles/ShInputs";
import { ShContainer } from "shared/SharedStyles/ShLayouts";
import CommonQuestionSidebar from "../CommonQuestionSidebar";

export const InterviewRemindersHelp = () => {
  const isMdScreen = IsMdScreen();
  const paddingValue = IsXsScreen() ? 1 : 3;

  return (
    <>
      <Stack padding={paddingValue} direction={"row"}>
        <ShContainer maxWidth='xl' margin='auto'>
          <ResourceTypography variant="h5" fontWeight={"bold"} gutterBottom>
            Interview Reminders
          </ResourceTypography>
          <ResourceTypography variant="body1" paragraph>
            Set up automated interview reminders to ensure smooth scheduling and attendance.
            Keep candidates and interviewers informed about upcoming interviews and important details.
          </ResourceTypography>

          <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
            Reminder Types
          </ResourceTypography>
          <Typography variant="body1" paragraph>
            Configure different types of reminders including initial confirmations, pre-interview
            reminders, and follow-up notifications. Customize the timing and content of each reminder.
          </Typography>

          <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
            Customization
          </ResourceTypography>
          <Typography variant="body1" paragraph>
            Personalize reminder messages with candidate and interview details. Include important
            information such as interview format, required preparation, and contact information.
          </Typography>

          <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
            Calendar Integration
          </ResourceTypography>
          <Typography variant="body1" paragraph>
            Reminders are automatically synced with your calendar system. Ensure all participants
            have the interview details in their preferred calendar application.
          </Typography>

          <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
            Response Tracking
          </ResourceTypography>
          <Typography variant="body1" paragraph>
            Track candidate responses to reminders and follow up as needed. Monitor attendance
            rates and adjust your reminder strategy based on effectiveness.
          </Typography>

          <Box paddingTop={2} paddingBottom={3}>
            <ShButton
              component={RouterLink}
              to="/employer/settings/automation/reminders/interview-reminders"
              color="primary"
              variant="contained"
            >
              Configure Interview Reminders
            </ShButton>
          </Box>
        </ShContainer>
        {!isMdScreen && <CommonQuestionSidebar />}
      </Stack>
    </>
  );
};

export default InterviewRemindersHelp; 